import { 
    Box, Button, Container, Table, TableBody, TableCell, TableHead, TableRow, 
    Pagination, Stack, Grid, Card, CardContent, Typography, Divider, Chip, 
    CircularProgress, TableContainer, Checkbox, IconButton
} from "@mui/material";
import { 
    VideogameAssetOutlined, SyncOutlined, 
    SystemUpdateAltOutlined, CallReceivedOutlined, AddCircleOutline, DeleteOutline, EditOutlined
} from "@mui/icons-material";
import swal from "sweetalert";
import { t } from "i18next";
import axios from "axios";
import { DashboardLayout } from "../../components/dashboard-layout";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { theme } from "../../theme"; 
import { useParams } from "react-router-dom";
import React, { useEffect, useState } from "react";
import "react-datepicker/dist/react-datepicker.css";
import { GetNameChoose } from "../../funcUtils";

// ==========================================
// THEME CHUẨN (ĐÃ ĐỒNG BỘ FONT PLUS JAKARTA SANS)
// ==========================================
const minimalistTheme = createTheme({
    palette: {
        background: { default: "#F9F9F9", paper: "#FFFFFF" }, 
        text: { primary: "#181C32", secondary: "#A1A5B7" }, 
        primary: { main: "#2563EB", light: "#EFF6FF" }, 
        success: { main: "#16A34A", light: "#DCFCE7" }, 
        danger: { main: "#EF4444", light: "#FEE2E2" },  
        warning: { main: "#F59E0B", light: "#FEF3C7" },
        purple: { main: "#7239EA", light: "#F8F5FF" }
    },
    typography: { fontFamily: "'Plus Jakarta Sans', sans-serif" },
    components: {
        MuiCard: { styleOverrides: { root: { borderRadius: "12px", border: "1px solid #EFF2F5", boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.02)" } } },
        MuiTable: { styleOverrides: { root: { border: "none !important", borderCollapse: "collapse !important" } } },
        MuiTableCell: { styleOverrides: { root: { borderBottom: "1px solid #EFF2F5 !important", padding: "14px 12px", color: "#3F4254", fontSize: "0.85rem", fontFamily: "'Plus Jakarta Sans', sans-serif !important", backgroundColor: "transparent !important" } } },
        MuiButton: { styleOverrides: { root: { fontFamily: "'Plus Jakarta Sans', sans-serif", textTransform: 'none' } } }
    }
});

// DANH SÁCH MÃ SẢNH GAME ĐỂ KIỂM TRA SỐ DƯ
const gameHalls = [
    { id: "4", name: "AG" }, { id: "79", name: "BBIN" }, { id: "98", name: "PG" }, { id: "275", name: "168Game" }, { id: "104", name: "CMD" },
    { id: "16", name: "CQ9" }, { id: "27", name: "DG" }, { id: "86", name: "Evolution" },
    { id: "142", name: "FB" }, { id: "140", name: "JILI" }, { id: "121", name: "KingMaker" },
    { id: "102", name: "V8 Poker" }, { id: "123", name: "King Poker" }, { id: "43", name: "MG" }, 
    { id: "39", name: "PP" }, { id: "174", name: "SABA" }, { id: "54", name: "SBO" }, 
    { id: "151", name: "UG" }, { id: "118", name: "WM" }, { id: "99", name: "TF" }, 
    { id: "112", name: "SEXY" }, { id: "111", name: "Playtech" }, { id: "28", name: "Allbet" }, 
    { id: "55", name: "JDB" }, { id: "202", name: "WS168" }, { id: "61", name: "IMES" }, 
    { id: "132", name: "SV388" }
];

// INTERCEPTOR ĐỂ NGOÀI CÙNG TRÁNH LỖI INFINITE LOOP
axios.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem("user");
        if (token) config.headers["Authorization"] = `Bearer ${token}`;
        return config;
    },
    (error) => Promise.reject(error)
);

function UserProfile() {
    const { id } = useParams();
    const [isShow, setShow] = useState(false);
    const [data, setData] = useState(null);
    const [isOpen, setOpen] = useState(false);
    const [isOpen2, setIsOpen2] = useState(false);
    
    const [profile, setProfile] = useState(null);
    const [bank, setBank] = useState(null);
    const [history, setHistory] = useState([]);
    const [daily, setDaily] = useState([]);
    const [employee, setEmployee] = useState([]);
    const [popup, setPopup] = useState(null);
    const [total, setTotal] = useState(null);
    const [isLoading, setLoading] = useState(true);

    const [dailyPage, setDailyPage] = useState(1);
    const dailyLimit = 5;

    const [historyPage, setHistoryPage] = useState(1);
    const [totalHistoryPages, setTotalHistoryPages] = useState(1);
    const historyLimit = 10;

    // State check số dư các sảnh
    const [hallBalances, setHallBalances] = useState({});
    const [isCheckingHalls, setIsCheckingHalls] = useState(false);
    const [selectedHalls, setSelectedHalls] = useState([]);

    // =====================================
    // STATE QUẢN LÝ SỰ KIỆN CÁ NHÂN MỚI
    // =====================================
    const [userEvents, setUserEvents] = useState([]);
    const [showEventModal, setShowEventModal] = useState(false);
    const [editingEvent, setEditingEvent] = useState(null); 

    function formatDate(m) {
        if (!m) return "";
        const d = new Date(m);
        return d.getUTCFullYear() + "/" + ("0" + (d.getMonth() + 1)).slice(-2) + "/" + ("0" + d.getDate()).slice(-2) + "  " + ("0" + d.getHours()).slice(-2) + ":" + ("0" + d.getMinutes()).slice(-2);
    }

    const openPopup = (item) => { setTotal(item); setIsOpen2(true); };
    const closePopup = () => { setIsOpen2(false); };

    const fetchUserProfile = async () => {
        try {
            const res = await axios.get(`${process.env.REACT_APP_API_URL}/auth/user/${id}`);
            setProfile(res.data.data);
            return res.data.data;
        } catch (error) {
            setProfile(null);
            return null;
        }
    };

    const fetchUserEvents = async (username) => {
        try {
            const res = await axios.get(`${process.env.REACT_APP_API_URL}/event/getevent`);
            if (res.data && res.data.success) {
                const specificEvents = res.data.data.filter(e => e.type === "SPECIFIC" && e.username === username);
                setUserEvents(specificEvents);
            }
        } catch (error) {
            console.error("Lỗi lấy danh sách sự kiện:", error);
            setUserEvents([]);
        }
    };

    useEffect(() => {
        if (!id) return;
        setLoading(true);

        const fetchInitialData = async () => {
            const userData = await fetchUserProfile();
            
            Promise.allSettled([
                axios.post(`${process.env.REACT_APP_API_URL}/bank/getBankUser`, { id: id }),
                axios.get(`${process.env.REACT_APP_API_URL}/auth/getEmployee`),
                userData?.code ? axios.post(`${process.env.REACT_APP_API_URL}/auth/getCustomer`, { code: userData.code }) : Promise.resolve(null)
            ]).then((results) => {
                if (results[0].status === 'fulfilled') {
                    const bankData = results[0].value.data.data;
                    setData(bankData);
                    // SỬA LỖI Ở ĐÂY: Lưu dữ liệu vào state bank (lấy object đầu tiên nếu API trả về mảng)
                    setBank(Array.isArray(bankData) ? bankData[0] : bankData);
                }
                if (results[1].status === 'fulfilled') {
                    setEmployee(results[1].value.data.data);
                    localStorage.setItem("data1", JSON.stringify(results[1].value.data.data));
                }
                if (results[2].status === 'fulfilled' && results[2].value) setDaily(results[2].value.data.data);
                
                if (userData?.username) {
                    fetchUserEvents(userData.username);
                }
                
                setLoading(false);
            });
        };

        fetchInitialData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id]);

    useEffect(() => {
        if (!id) return;
        axios.get(`${process.env.REACT_APP_API_URL}/history/historyuser/${id}?page=${historyPage}&limit=${historyLimit}`)
            .then((res) => {
                if (res.data.success) {
                    setHistory(res.data.data);
                    setTotalHistoryPages(res.data.totalPages || 1);
                }
            })
            .catch(() => { setHistory([]); });
    }, [id, historyPage]);

    const handleHistoryPageChange = (event, newPage) => setHistoryPage(newPage);

    const handleSubmit = (e) => {
        e.preventDefault();
        axios.post(`${process.env.REACT_APP_API_URL}/auth/changepassword`, { id: id, password: e.target.password.value })
            .then(() => swal(t('success'), "", "success")).catch(() => swal(t('error'), "", "error"));
    };

    const handleSubmit2 = (e) => {
        e.preventDefault();
        axios.post(`${process.env.REACT_APP_API_URL}/auth/changepassword`, { id: id, paypwd: e.target.paypwd.value })
            .then(() => swal(t('success'), "", "success")).catch(() => swal(t('error'), "", "error"));
    };

    // =========================================================================
    // CẬP NHẬT NGÂN HÀNG
    // =========================================================================
    const handleSubmitBank = (e) => {
        e.preventDefault();
        const formData = { 
            id: bank?._id, 
            name_bank: e.target.name_bank.value, 
            stk: e.target.stk.value, 
            fullname: e.target.fullname.value 
        };
        axios.post(`${process.env.REACT_APP_API_URL}/bank/updateBank`, formData)
            .then(() => { 
                setShow(false); 
                swal(t('success') || "Thành công", "Cập nhật ngân hàng thành công", "success");
                // Cập nhật local state để hiển thị ngay
                setBank({...bank, name_bank: formData.name_bank, stk: formData.stk, fullname: formData.fullname});
            })
            .catch(() => { 
                setShow(false); 
                swal(t('error') || "Lỗi", "Không thể cập nhật ngân hàng", "error"); 
            });
    };

    // =========================================================================
    // KHU VỰC THAO TÁC SỰ KIỆN CÁ NHÂN (XỬ LÝ LƯU / SỬA / XÓA)
    // =========================================================================
    const handleSaveEvent = (e) => {
        e.preventDefault();
        const payload = {
            title: e.target.title.value,
            content: e.target.content.value,
            bonus_type: e.target.bonus_type.value,
            bonus_value: Number(e.target.bonus_value.value),
            min_deposit: Number(e.target.min_deposit.value),
            turns: Number(e.target.turns.value),
            type: "SPECIFIC",
            username: profile.username,
            status: "Active"
        };
        
        if (editingEvent) {
            payload.id = editingEvent._id; 
            axios.post(`${process.env.REACT_APP_API_URL}/event/editevent`, payload)
                .then(() => {
                    swal("Thành công", "Đã cập nhật sự kiện thành công!", "success");
                    setShowEventModal(false);
                    setEditingEvent(null);
                    fetchUserEvents(profile.username);
                })
                .catch(() => swal("Lỗi", "Không thể cập nhật sự kiện", "error"));
        } else {
            axios.post(`${process.env.REACT_APP_API_URL}/event/newevent`, payload)
                .then(() => {
                    swal("Thành công", "Đã tạo sự kiện riêng cho tài khoản này!", "success");
                    setShowEventModal(false);
                    fetchUserEvents(profile.username);
                })
                .catch(() => swal("Lỗi", "Không thể tạo sự kiện lúc này", "error"));
        }
    };

    const handleDeleteEvent = async (eventId) => {
        const isConfirm = await swal({
            title: "Xóa sự kiện?",
            text: "Sự kiện này sẽ bị xóa khỏi danh sách của khách hàng.",
            icon: "warning",
            buttons: ["Hủy", "Xóa"],
            dangerMode: true,
        });

        if (isConfirm) {
            axios.post(`${process.env.REACT_APP_API_URL}/event/deleteevent`, { id: eventId })
                .then(() => {
                    swal("Đã xóa", "Xóa sự kiện thành công", "success");
                    fetchUserEvents(profile.username);
                })
                .catch(() => swal("Lỗi", "Không thể xóa sự kiện", "error"));
        }
    };

    const handleCheckAllHalls = async () => {
        setIsCheckingHalls(true);
        setHallBalances({});
        setSelectedHalls([]); 

        const promises = gameHalls.map(hall => {
            return axios.post(`${process.env.REACT_APP_API_URL}/casino/getbalance`, { 
                id: id, 
                product_type: hall.id 
            })
            .then(res => ({ id: hall.id, balance: res.data?.data?.balance || 0 }))
            .catch(() => ({ id: hall.id, balance: "Lỗi" }));
        });

        const results = await Promise.all(promises);
        const newBalances = {};
        results.forEach(r => { newBalances[r.id] = r.balance; });
        
        setHallBalances(newBalances);
        setIsCheckingHalls(false);
    };

    const handleToggleSelectHall = (hallId) => {
        setSelectedHalls(prev => 
            prev.includes(hallId) ? prev.filter(h => h !== hallId) : [...prev, hallId]
        );
    };

    const handleRecallPoints = async (hallId, hallName, points) => {
        if (!points || points <= 0 || points === "Lỗi") return;
        
        const isConfirm = await swal({
            title: `Thu hồi điểm từ ${hallName}?`,
            text: `Xác nhận thu hồi ${Number(points).toLocaleString("vi-VN")} điểm (~ ${(points * 1000).toLocaleString("vi-VN")} VNĐ) về ví chính.`,
            icon: "warning",
            buttons: ["Hủy", "Thu hồi ngay"],
            dangerMode: true,
        });

        if (isConfirm) {
            setLoading(true);
            try {
                await axios.post(`${process.env.REACT_APP_API_URL}/casino/transfer`, {
                    id: id,
                    product_type: hallId,
                    money: points,
                    type: 2
                });
                swal("Thành công!", `Đã thu hồi điểm từ sảnh ${hallName}`, "success");
                setHallBalances(prev => ({...prev, [hallId]: 0}));
                fetchUserProfile();
            } catch (error) {
                swal("Thất bại", error?.response?.data?.message || "Không thể thu hồi điểm lúc này", "error");
            }
            setLoading(false);
        }
    };

    const executeRecall = async (hallsToRecall) => {
        setLoading(true);
        let successCount = 0;
        let currentBals = { ...hallBalances };

        for (const hallId of hallsToRecall) {
            try {
                await axios.post(`${process.env.REACT_APP_API_URL}/casino/transfer`, { 
                    id: id,
                    product_type: hallId,
                    money: currentBals[hallId], 
                    type: 2
                });
                successCount++;
                currentBals[hallId] = 0;
            } catch (e) {
                console.log(`Lỗi thu hồi sảnh ${hallId}:`, e);
            }
        }

        setHallBalances(currentBals);
        setSelectedHalls([]);
        fetchUserProfile(); 
        setLoading(false);
        
        swal("Hoàn tất", `Đã thu hồi thành công ${successCount}/${hallsToRecall.length} sảnh.`, "success");
    };

    const handleRecallSelected = async () => {
        const hallsWithValidPoints = selectedHalls.filter(hid => typeof hallBalances[hid] === "number" && hallBalances[hid] > 0);
        if (hallsWithValidPoints.length === 0) return swal("Lỗi", "Vui lòng tick chọn ít nhất 1 sảnh có số dư lớn hơn 0!", "warning");
        const isConfirm = await swal({
            title: "Thu hồi sảnh đã chọn?",
            text: `Bạn sẽ thu hồi điểm từ ${hallsWithValidPoints.length} sảnh đã tick về ví chính.`,
            icon: "warning",
            buttons: ["Hủy", "Tiến hành"],
            dangerMode: true,
        });
        if (isConfirm) executeRecall(hallsWithValidPoints);
    };

    const handleRecallAll = async () => {
        const allHallsWithPoints = Object.keys(hallBalances).filter(hid => typeof hallBalances[hid] === "number" && hallBalances[hid] > 0);
        if (allHallsWithPoints.length === 0) return swal("Thông báo", "Hiện tại không có sảnh nào có điểm để thu hồi.", "info");
        const isConfirm = await swal({
            title: "Thu hồi TẤT CẢ?",
            text: `Hệ thống sẽ gom toàn bộ điểm từ ${allHallsWithPoints.length} sảnh về ví chính.`,
            icon: "warning",
            buttons: ["Hủy", "Thu hồi tất cả"],
            dangerMode: true,
        });
        if (isConfirm) executeRecall(allHallsWithPoints);
    };

    const inputStyle = {
        height: "46px", padding: "0 14px", border: "1px solid #E4E6EF", borderRadius: "8px", 
        outline: "none", fontSize: "0.9rem", fontWeight: "600", fontFamily: "'Plus Jakarta Sans', sans-serif", 
        color: "#181C32", width: "100%", boxSizing: "border-box", backgroundColor: "#F9F9F9", transition: "border-color 0.2s ease"
    };

    const tableHeadSx = { color: "#A1A5B7 !important", fontWeight: "700 !important", fontSize: "0.75rem !important", backgroundColor: "#FFFFFF !important", borderBottom: "2px solid #EFF2F5 !important", textTransform: "uppercase !important" };

    const InfoRow = ({ label, value, isBold, color }) => (
        <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ py: 1.2, borderBottom: '1px dashed #EFF2F5' }}>
            <Typography variant="body2" color="text.secondary" fontWeight="600">{label}</Typography>
            <Typography variant="body2" fontWeight={isBold ? 800 : 600} color={color || "text.primary"}>{value}</Typography>
        </Stack>
    );

    let currentHistory = history || [];
    let displayHistoryPages = totalHistoryPages > 1 ? totalHistoryPages : 1;
    if (totalHistoryPages <= 1 && history && history.length > historyLimit) {
        currentHistory = history.slice((historyPage - 1) * historyLimit, historyPage * historyLimit);
        displayHistoryPages = Math.ceil(history.length / historyLimit);
    }

    return (
        <ThemeProvider theme={theme}>
            <DashboardLayout>
                <ThemeProvider theme={minimalistTheme}>
                    <style>{`
                        @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap');
                        .safe-user-profile-zone * { box-sizing: border-box; font-family: 'Plus Jakarta Sans', sans-serif !important; text-align: left; }
                        .custom-input-metronic:focus { border-color: #2563EB !important; background-color: #FFFFFF !important; }
                        .hall-card { cursor: pointer; transition: all 0.2s ease; border: 2px solid transparent; }
                        .hall-card:hover { transform: translateY(-3px); box-shadow: 0 5px 15px rgba(0,0,0,0.05); }
                        .hall-card.selected { border-color: #2563EB; background-color: #EFF6FF !important; }
                    `}</style>
                    
                    <Box className="safe-user-profile-zone" component="main" sx={{ flexGrow: 1, py: 4, backgroundColor: 'background.default', minHeight: 'calc(100vh - 70px)', position: 'relative' }}>
                        
                        {isLoading && (
                            <Box sx={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(255,255,255,0.6)', zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center', backdropFilter: 'blur(2px)' }}>
                                <CircularProgress size={50} sx={{ color: '#2563EB' }} />
                            </Box>
                        )}

                        <Container maxWidth="xl">
                            <Box sx={{ mb: 4 }}>
                                <Typography variant="h5" fontWeight="800" color="#181C32" gutterBottom>
                                    Chi Tiết Tài Khoản
                                </Typography>
                                <Typography variant="body2" color="#7E8299" fontWeight="500">
                                    Quản lý thông tin cá nhân, số dư, tỷ lệ hoa hồng và lịch sử giao dịch của người dùng
                                </Typography>
                            </Box>

                            <Grid container spacing={3} sx={{ mb: 4 }}>
                                {/* CỘT 1: BẢO MẬT & THÔNG TIN */}
                                <Grid item xs={12} md={4}>
                                    <Card sx={{ height: '100%' }}>
                                        <CardContent>
                                            <Typography variant="h6" fontWeight="800" mb={3} fontSize="1.1rem">Thông tin & Bảo mật</Typography>
                                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 3 }}>
                                                <Box sx={{ width: 50, height: 50, borderRadius: '50%', backgroundColor: '#EFF6FF', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#2563EB', fontWeight: '800', fontSize: '1.2rem' }}>
                                                    {profile?.username?.charAt(0).toUpperCase() || "U"}
                                                </Box>
                                                <Box>
                                                    <Typography variant="subtitle2" color="text.secondary" fontSize="0.75rem" fontWeight="600">Tên đăng nhập</Typography>
                                                    <Typography variant="h6" color="primary.main" fontWeight="800">{profile?.username}</Typography>
                                                </Box>
                                            </Box>
                                            <form onSubmit={handleSubmit}>
                                                <Typography variant="caption" fontWeight="700" color="text.secondary" mb={0.5} display="block">{t("pwd")}</Typography>
                                                <Stack direction="row" spacing={1} mb={2} alignItems="center">
                                                    <input className="custom-input-metronic" style={inputStyle} type="text" name="password" placeholder="Mật khẩu mới..." />
                                                    <Button variant="contained" type="submit" sx={{ boxShadow: 'none', height: '46px', px: 3, borderRadius: '8px', fontWeight: '700' }}>Lưu</Button>
                                                </Stack>
                                            </form>
                                            <form onSubmit={handleSubmit2}>
                                                <Typography variant="caption" fontWeight="700" color="text.secondary" mb={0.5} display="block">{t("pwd2")}</Typography>
                                                <Stack direction="row" spacing={1} mb={3} alignItems="center">
                                                    <input className="custom-input-metronic" style={inputStyle} type="text" name="paypwd" defaultValue={profile?.paypwd} placeholder="Mật khẩu rút tiền..." />
                                                    <Button variant="contained" type="submit" sx={{ boxShadow: 'none', height: '46px', px: 3, borderRadius: '8px', fontWeight: '700' }}>Lưu</Button>
                                                </Stack>
                                            </form>
                                            <Divider sx={{ my: 2, borderColor: '#EFF2F5' }} />
                                            <form onSubmit={(e) => {
                                                e.preventDefault();
                                                axios.post(`${process.env.REACT_APP_API_URL}/auth/updateuser/${id}`, { id: id, sdt: e.target.sdt.value, name: e.target.name.value, aff: e.target.aff.value })
                                                    .then(() => swal(t("success"), "", "success")).catch(() => swal(t("error"), "", "error"));
                                            }}>
                                                <Typography variant="caption" fontWeight="700" color="text.secondary" mb={0.5} display="block">{t("agent_code")}</Typography>
                                                <input className="custom-input-metronic" style={{...inputStyle, marginBottom: '12px'}} defaultValue={profile?.aff || "admin"} name="aff" />
                                                <Typography variant="caption" fontWeight="700" color="text.secondary" mb={0.5} display="block">{t("phone")}</Typography>
                                                <input className="custom-input-metronic" style={{...inputStyle, marginBottom: '12px'}} defaultValue={profile?.sdt ? "0" + profile?.sdt : ""} name="sdt" />
                                                <Typography variant="caption" fontWeight="700" color="text.secondary" mb={0.5} display="block">{t("fullname")}</Typography>
                                                <Stack direction="row" spacing={1} alignItems="center">
                                                    <input className="custom-input-metronic" style={inputStyle} defaultValue={profile?.name || ""} name="name" />
                                                    <Button variant="contained" type="submit" sx={{ boxShadow: 'none', minWidth: '105px', height: '46px', borderRadius: '8px', fontWeight: '700' }}>Cập nhật</Button>
                                                </Stack>
                                            </form>

                                            {/* ===== THÔNG TIN NGÂN HÀNG ===== */}
                                            <Divider sx={{ my: 2, borderColor: '#EFF2F5' }} />
                                            <Box display="flex" justifyContent="space-between" alignItems="center">
                                                <Box>
                                                    <Typography variant="caption" fontWeight="700" color="text.secondary" mb={0.5} display="block">Ngân hàng liên kết</Typography>
                                                    {bank ? (
                                                        <Typography variant="body2" fontWeight="800" color="primary.main">
                                                            {bank.name_bank} - {bank.stk}
                                                            <br />
                                                            <span style={{color: '#181C32'}}>{bank.fullname}</span>
                                                        </Typography>
                                                    ) : (
                                                        <Typography variant="body2" fontWeight="600" color="error">Chưa có thông tin</Typography>
                                                    )}
                                                </Box>
                                                <Button 
                                                    variant="outlined" 
                                                    size="small" 
                                                    onClick={() => setShow(true)} 
                                                    sx={{ borderRadius: '8px', fontWeight: '700', height: '40px' }}
                                                >
                                                    {t("edit") || "Sửa NH"}
                                                </Button>
                                            </Box>
                                            {/* ================================= */}
                                        </CardContent>
                                    </Card>
                                </Grid>

                                {/* CỘT 2: CHỈ SỐ TÀI KHOẢN */}
                                <Grid item xs={12} md={4}>
                                    <Card sx={{ height: '100%' }}>
                                        <CardContent>
                                            <Typography variant="h6" fontWeight="800" mb={3} fontSize="1.1rem">Chỉ số tài khoản</Typography>
                                            <InfoRow label={t("balance")} value={`${Math.floor(profile?.money || 0)?.toLocaleString("vi-VN")} đ`} isBold color="#16A34A" />
                                            <InfoRow label={t("commission_pending")} value={`${Number(profile?.moneyaff || 0)?.toLocaleString("vi-VN")} đ`} isBold color="#F59E0B" />
                                            <InfoRow label={t("totalbet")} value={Number(profile?.totalbet || 0)?.toLocaleString("vi-VN")} />
                                            <InfoRow label={t("totalbet_api")} value={Number(profile?.totalbetapi || 0)?.toLocaleString("vi-VN")} />
                                            <InfoRow label={t("admin_add")} value={Number(profile?.adminadd || 0)?.toLocaleString("vi-VN")} color="#2563EB" />
                                            <InfoRow label={t("admin_dec")} value={Number(profile?.admindec || 0)?.toLocaleString("vi-VN")} color="#EF4444" />
                                            <InfoRow label={t("admin_give")} value={Number(profile?.adminthuong || 0)?.toLocaleString("vi-VN")} />
                                            <InfoRow label={t("total_win")} value={Number(profile?.totalwin || 0)?.toLocaleString("vi-VN")} color="#16A34A" />
                                            <InfoRow label={t("referrer")} value={employee?.find((x) => x.code === profile?.aff)?.username || t("empty")} />
                                            <InfoRow label={t("created")} value={formatDate(profile?.createdAt ? new Date(profile.createdAt) : null)} />
                                           <form onSubmit={(e) => {
    e.preventDefault();
    // Ép kiểu về Number để backend lưu chuẩn xác
    axios.post(`${process.env.REACT_APP_API_URL}/auth/update`, { id: id, level: Number(e.target.vip.value) })
        .then(() => {
            swal(t("success"), "Cập nhật cấp VIP thành công!", "success");
            fetchUserProfile(); // Tự động load lại dữ liệu để UI cập nhật ngay lập tức
        }).catch(() => swal(t("error"), "Có lỗi xảy ra", "error"));
}} style={{ marginTop: '16px' }}>
    <Stack direction="row" alignItems="center" justifyContent="space-between">
        <Typography variant="body2" color="text.secondary" fontWeight="700">VIP LEVEL</Typography>
        <Stack direction="row" spacing={1} alignItems="center">
            <select 
                className="custom-input-metronic" 
                name="vip" 
                // Đổi defaultValue thành value và thêm onChange để React đồng bộ dữ liệu chuẩn
                value={profile?.level ?? 0} 
                onChange={(e) => setProfile({...profile, level: Number(e.target.value)})}
                style={{...inputStyle, width: "120px", cursor: 'pointer'}}
            >
                {Array.from({ length: 61 }, (_, i) => i).map(lvl => <option key={lvl} value={lvl}>Cấp {lvl}</option>)}
            </select>
            <Button variant="outlined" type="submit" sx={{ height: '46px', px: 3, borderRadius: '8px', fontWeight: '700' }}>Lưu</Button>
        </Stack>
    </Stack>
</form>
                                        </CardContent>
                                    </Card>
                                </Grid>

                                {/* CỘT 3: TỶ LỆ ĐẠI LÝ */}
                                <Grid item xs={12} md={4}>
                                    <Card sx={{ height: '100%' }}>
                                        <CardContent>
                                            <Typography variant="h6" fontWeight="800" mb={3} fontSize="1.1rem">{t("agent_rate")}</Typography>
                                            <form onSubmit={(e) => {
                                                e.preventDefault();
                                                axios.post(`${process.env.REACT_APP_API_URL}/auth/update`, { id: id, hoahong: e.target.hoahong.value, hoahonglive: e.target.hoahonglive.value, hoahongslots: e.target.hoahongslots.value })
                                                    .then(() => swal(t("success"), "", "success")).catch(() => swal(t("error"), "", "error"));
                                            }}>
                                                <Box sx={{ p: 2, backgroundColor: '#F9F9F9', borderRadius: '8px', border: '1px solid #EFF2F5', mb: 3 }}>
                                                    <Stack spacing={2.5}>
                                                        <Box display="flex" justifyContent="space-between" alignItems="center">
                                                            <Typography variant="body2" fontWeight="700">{t("lottery_rate")}</Typography>
                                                            <Box display="flex" alignItems="center" gap={1}>
                                                                <input className="custom-input-metronic" name="hoahong" defaultValue={profile?.hoahong} style={{...inputStyle, width: "80px", textAlign: "center"}} /> %
                                                            </Box>
                                                        </Box>
                                                        <Box display="flex" justifyContent="space-between" alignItems="center">
                                                            <Typography variant="body2" fontWeight="700">{t("casino_rate")}</Typography>
                                                            <Box display="flex" alignItems="center" gap={1}>
                                                                <input className="custom-input-metronic" name="hoahonglive" defaultValue={profile?.hoahonglive} style={{...inputStyle, width: "80px", textAlign: "center"}} /> %
                                                            </Box>
                                                        </Box>
                                                        <Box display="flex" justifyContent="space-between" alignItems="center">
                                                            <Typography variant="body2" fontWeight="700">{t("slot_rate")}</Typography>
                                                            <Box display="flex" alignItems="center" gap={1}>
                                                                <input className="custom-input-metronic" name="hoahongslots" defaultValue={profile?.hoahongslots} style={{...inputStyle, width: "80px", textAlign: "center"}} /> %
                                                            </Box>
                                                        </Box>
                                                    </Stack>
                                                </Box>
                                                <Button variant="contained" fullWidth type="submit" sx={{ boxShadow: 'none', height: '46px', borderRadius: '8px', fontSize: '0.95rem', fontWeight: '800' }}>Cập nhật Tỉ lệ</Button>
                                            </form>
                                        </CardContent>
                                    </Card>
                                </Grid>

                                {/* KIỂM TRA SỐ DƯ SẢNH */}
                                <Grid item xs={12}>
                                    <Card>
                                        <CardContent>
                                            <Box display="flex" justifyContent="space-between" alignItems="center" mb={3} flexWrap="wrap" gap={2}>
                                                <Typography variant="h6" fontWeight="800" fontSize="1.1rem" display="flex" alignItems="center" gap={1}>
                                                    <VideogameAssetOutlined color="primary" /> Kiểm Tra & Thu Hồi Số Dư Sảnh
                                                </Typography>
                                                
                                                <Stack direction="row" spacing={2} flexWrap="wrap" useFlexGap>
                                                    <Button 
                                                        variant="contained" 
                                                        onClick={handleCheckAllHalls}
                                                        disabled={isCheckingHalls}
                                                        startIcon={isCheckingHalls ? <CircularProgress size={20} color="inherit" /> : <SyncOutlined />}
                                                        sx={{ boxShadow: 'none', borderRadius: '8px', fontWeight: '800', backgroundColor: '#181C32', '&:hover': { backgroundColor: '#3F4254' } }}
                                                    >
                                                        {isCheckingHalls ? "Đang quét..." : "Kiểm Tra Số Dư"}
                                                    </Button>
                                                    <Button 
                                                        variant="outlined" color="primary" 
                                                        onClick={handleRecallSelected}
                                                        disabled={selectedHalls.length === 0}
                                                        startIcon={<CallReceivedOutlined />}
                                                        sx={{ borderRadius: '8px', fontWeight: '800', borderWidth: '2px', '&:hover': {borderWidth: '2px'} }}
                                                    >
                                                        Thu hồi Đã chọn ({selectedHalls.length})
                                                    </Button>
                                                    <Button 
                                                        variant="contained" color="error" 
                                                        onClick={handleRecallAll}
                                                        startIcon={<SystemUpdateAltOutlined />}
                                                        sx={{ boxShadow: 'none', borderRadius: '8px', fontWeight: '800' }}
                                                    >
                                                        Thu Hồi Tất Cả
                                                    </Button>
                                                </Stack>
                                            </Box>
                                            
                                            <Grid container spacing={2}>
                                                {gameHalls.map((hall) => {
                                                    const points = hallBalances[hall.id];
                                                    const isError = points === "Lỗi";
                                                    const hasBalance = typeof points === "number" && points > 0;
                                                    const isSelected = selectedHalls.includes(hall.id);
                                                    
                                                    return (
                                                        <Grid item xs={12} sm={6} md={4} lg={3} xl={2.4} key={hall.id}>
                                                            <Box 
                                                                className={`hall-card ${isSelected ? 'selected' : ''}`}
                                                                onClick={() => { if (!isCheckingHalls) handleToggleSelectHall(hall.id); }}
                                                                sx={{ 
                                                                    p: 2, 
                                                                    backgroundColor: hasBalance ? '#F8FBFF' : '#F9F9F9', 
                                                                    borderRadius: '8px', 
                                                                    border: '2px solid',
                                                                    borderColor: isSelected ? '#2563EB' : (hasBalance ? '#BFDBFE' : '#EFF2F5'), 
                                                                    display: 'flex', 
                                                                    flexDirection: 'column', 
                                                                    height: '100%', 
                                                                    position: 'relative'
                                                                }}
                                                            >
                                                                <Box display="flex" justifyContent="space-between" alignItems="flex-start">
                                                                    <Typography variant="subtitle2" fontWeight="800" color="text.secondary" mb={1}>{hall.name}</Typography>
                                                                    <Checkbox 
                                                                        checked={isSelected}
                                                                        onChange={() => { if (!isCheckingHalls) handleToggleSelectHall(hall.id); }}
                                                                        sx={{ p: 0, '& .MuiSvgIcon-root': { fontSize: 20 }, color: '#A1A5B7', '&.Mui-checked': { color: '#2563EB' } }}
                                                                    />
                                                                </Box>
                                                                
                                                                <Box sx={{ flexGrow: 1, mt: 1 }}>
                                                                    {isError ? (
                                                                        <Typography variant="body2" fontWeight="700" color="error">Bảo trì / Lỗi</Typography>
                                                                    ) : points !== undefined ? (
                                                                        <>
                                                                            <Typography variant="h6" fontWeight="900" color={hasBalance ? "primary" : "text.primary"}>
                                                                                {Number(points).toLocaleString("vi-VN")} <span style={{fontSize: '0.8rem', fontWeight: 700}}>Điểm</span>
                                                                            </Typography>
                                                                            <Typography variant="caption" color="text.secondary" fontWeight="600" display="block" mt={0.5}>
                                                                                ≈ {(Number(points) * 1000).toLocaleString("vi-VN")} đ
                                                                            </Typography>
                                                                        </>
                                                                    ) : (
                                                                        <Typography variant="body2" fontWeight="600" color="text.secondary">Chưa kiểm tra</Typography>
                                                                    )}
                                                                </Box>

                                                                {hasBalance && (
                                                                    <Button 
                                                                        variant="outlined" size="small" fullWidth
                                                                        onClick={(e) => {
                                                                            e.stopPropagation(); 
                                                                            handleRecallPoints(hall.id, hall.name, points);
                                                                        }}
                                                                        sx={{ mt: 2, fontWeight: 700, borderRadius: '6px', py: 0.5, borderColor: '#2563EB', color: '#2563EB' }}
                                                                    >
                                                                        Thu hồi
                                                                    </Button>
                                                                )}
                                                            </Box>
                                                        </Grid>
                                                    );
                                                })}
                                            </Grid>
                                        </CardContent>
                                    </Card>
                                </Grid>

                                {/* =========================================================
                                    KHU VỰC CẬP NHẬT: QUẢN LÝ SỰ KIỆN CÁ NHÂN (XÓA / SỬA / XEM LƯỢT)
                                    ========================================================= */}
                                <Grid item xs={12}>
                                    <Card>
                                        <CardContent>
                                            <Box display="flex" justifyContent="space-between" alignItems="center" mb={3} flexWrap="wrap" gap={2}>
                                                <Typography variant="h6" fontWeight="800" fontSize="1.1rem" color="#7239EA">
                                                    Quản lý Sự kiện Cá nhân
                                                </Typography>
                                                <Button 
                                                    variant="contained" 
                                                    onClick={() => {
                                                        setEditingEvent(null); 
                                                        setShowEventModal(true);
                                                    }}
                                                    startIcon={<AddCircleOutline />}
                                                    sx={{ backgroundColor: '#7239EA', '&:hover': { backgroundColor: '#5014d0' }, boxShadow: 'none', borderRadius: '8px', fontWeight: '800' }}
                                                >
                                                    Tạo Sự kiện cho User này
                                                </Button>
                                            </Box>
                                            
                                            <TableContainer sx={{ border: '1px solid #EFF2F5', borderRadius: '8px' }}>
                                                  <Table sx={{ minWidth: 1460 }}>
                                                    <TableHead>
                                                        <TableRow sx={{ backgroundColor: '#F8F5FF' }}>
                                                            <TableCell sx={{...tableHeadSx, backgroundColor: 'transparent !important'}}>Tiêu đề Sự kiện</TableCell>
                                                            <TableCell sx={{...tableHeadSx, backgroundColor: 'transparent !important'}}>Nội dung</TableCell>
                                                            <TableCell sx={{...tableHeadSx, backgroundColor: 'transparent !important'}}>Phần thưởng</TableCell>
                                                            <TableCell sx={{...tableHeadSx, backgroundColor: 'transparent !important'}}>Nạp Tối thiểu</TableCell>
                                                            <TableCell sx={{...tableHeadSx, backgroundColor: 'transparent !important'}}>Số lượt sử dụng</TableCell>
                                                            <TableCell sx={{...tableHeadSx, backgroundColor: 'transparent !important'}} align="right">Hành động</TableCell>
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        {userEvents.length > 0 ? userEvents.map((evt, idx) => (
                                                            <TableRow key={idx}>
                                                                <TableCell sx={{ fontWeight: 700 }}>{evt.title}</TableCell>
                                                                <TableCell>{evt.content}</TableCell>
                                                                <TableCell>
                                                                    <Chip 
                                                                        label={evt.bonus_type === 'FIXED' ? `+${Number(evt.bonus_value).toLocaleString('vi-VN')} VNĐ` : `+${evt.bonus_value}%`} 
                                                                        size="small" 
                                                                        sx={{ backgroundColor: '#F8F5FF', color: '#7239EA', fontWeight: 800 }} 
                                                                    />
                                                                </TableCell>
                                                                <TableCell sx={{ fontWeight: 600 }}>{Number(evt.min_deposit).toLocaleString('vi-VN')} đ</TableCell>
                                                                <TableCell sx={{ fontWeight: 700, color: '#16A34A' }}>{evt.turns !== undefined ? `${evt.turns} lần` : "1 lần"}</TableCell>
                                                                <TableCell align="right">
                                                                    <IconButton color="primary" onClick={() => {
                                                                        setEditingEvent(evt); 
                                                                        setShowEventModal(true); 
                                                                    }} sx={{ mr: 1 }}>
                                                                        <EditOutlined />
                                                                    </IconButton>
                                                                    <IconButton color="error" onClick={() => handleDeleteEvent(evt._id)}>
                                                                        <DeleteOutline />
                                                                    </IconButton>
                                                                </TableCell>
                                                            </TableRow>
                                                        )) : (
                                                            <TableRow>
                                                                <TableCell colSpan={6} align="center" sx={{ py: 4, color: '#A1A5B7', fontWeight: 600 }}>
                                                                    Chưa có sự kiện nào cài đặt riêng cho người dùng này.
                                                                </TableCell>
                                                            </TableRow>
                                                        )}
                                                    </TableBody>
                                                </Table>
                                            </TableContainer>
                                        </CardContent>
                                    </Card>
                                </Grid>
                                {/* ========================================================= */}

                            </Grid>

                            {/* LỊCH SỬ GIAO DỊCH / CƯỢC */}
                            <Card>
                                <CardContent sx={{ p: 0 }}>
                                    <Box sx={{ p: 2.5, borderBottom: '1px solid #EFF2F5' }}>
                                        <Typography variant="h6" fontWeight="800" fontSize="1.1rem">Lịch sử giao dịch / cược</Typography>
                                    </Box>
                                    <TableContainer sx={{ overflowX: 'auto' }}>
                                        <Table sx={{ minWidth: 1460 }}>
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell sx={{ ...tableHeadSx, width: '5%' }}>STT</TableCell>
                                                    <TableCell sx={{ ...tableHeadSx, width: '12%' }}>PHIÊN</TableCell>
                                                    <TableCell sx={{ ...tableHeadSx, width: '12%' }}>LOẠI GIAO DỊCH</TableCell>
                                                    <TableCell sx={{ ...tableHeadSx, width: '15%' }}>CHI TIẾT</TableCell>
                                                    <TableCell sx={{ ...tableHeadSx, width: '10%' }}>KẾT QUẢ</TableCell>
                                                    <TableCell sx={{ ...tableHeadSx, width: '8%' }}>TRẠNG THÁI</TableCell>
                                                    <TableCell align="right" sx={{ ...tableHeadSx, width: '9%' }}>SỐ TIỀN</TableCell>
                                                    <TableCell align="right" sx={{ ...tableHeadSx, width: '9%' }}>THẮNG/THÀNH CÔNG</TableCell>
                                                    <TableCell align="right" sx={{ ...tableHeadSx, width: '8%' }}>SỐ DƯ SAU</TableCell>
                                                    <TableCell align="right" sx={{ ...tableHeadSx, width: '12%' }}>THỜI GIAN</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {currentHistory && currentHistory.length > 0 ? (
                                                    currentHistory.map((item, index) => (
                                                        <TableRow key={index} hover sx={{ verticalAlign: "top" }}>
                                                            <TableCell sx={{ fontWeight: 700, color: '#A1A5B7' }}>{(historyPage - 1) * historyLimit + index + 1}</TableCell>
                                                            <TableCell sx={{ fontWeight: 600 }}>{item?.id_bet?.id_bet ? item?.id_bet?.id_bet : item?.id_bet}</TableCell>
                                                            <TableCell sx={{ fontWeight: 800, color: '#2563EB' }}>{item?.sanh}</TableCell>
                                                            
                                                            <TableCell sx={{ maxWidth: "250px" }}>
                                                                {item?.id_bet?.result ? (
                                                                    <>
                                                                        {item?.sanh === "Greedy" ? (
                                                                            <Box display="flex" flexWrap="wrap" gap={1}>
                                                                                {Object.entries(item?.detail).map(([key, value]) => value > 0 && (
                                                                                    <Box key={key} display="flex" alignItems="center" gap={0.5}>
                                                                                        <img alt="" src={require(`../game/Greedy/images/food_${Number(key.slice(-1)) + 1}.png`)} style={{ height: "20px" }} />
                                                                                        <Typography variant="caption" fontWeight="700">: {(value * 1000).toLocaleString("vi-VN")}</Typography>
                                                                                    </Box>
                                                                                ))}
                                                                            </Box>
                                                                        ) : item?.sanh === "CatDog" ? (
                                                                            <Box display="flex" flexWrap="wrap" gap={1}>
                                                                                {Object.entries(item?.detail).map(([key, value]) => value > 0 && (
                                                                                    <Typography key={key} variant="caption" fontWeight="700" display="block">
                                                                                        {GetNameChoose(key.slice(-1), item?.type, item?.sanh) || "Chọn " + key.slice(-1)} : {(value * 1000).toLocaleString("vi-VN")}
                                                                                    </Typography>
                                                                                ))}
                                                                            </Box>
                                                                        ) : item?.id_bet ? (
                                                                            <Typography variant="body2" fontWeight="600">{GetNameChoose(item?.state, item?.type, item?.sanh) || "Chọn " + item?.state}</Typography>
                                                                        ) : (
                                                                            <Typography variant="body2" fontWeight="500">{item?.detail}</Typography>
                                                                        )}
                                                                    </>
                                                                ) : (
                                                                    <Typography variant="body2" fontWeight="500">{item?.detail}</Typography>
                                                                )}
                                                            </TableCell>

                                                            <TableCell>
                                                                {item?.id_bet?.result && (
                                                                    <Box display="flex" flexWrap="wrap" gap={0.5}>
                                                                        {item?.sanh === "Greedy" && <img alt="" src={require(`../game/Greedy/images/food_${item?.id_bet?.result}.png`)} style={{ height: "25px" }} />}
                                                                        {item?.sanh === "CatDog" && <Typography variant="body2" fontWeight="800" color="#2563EB">{GetNameChoose(item?.id_bet?.result, item?.type, item?.sanh)?.replace("Chọn", "")}</Typography>}
                                                                        {item?.sanh.indexOf("Tài xỉu") !== -1 && (
                                                                            item?.id_bet?.result?.split(" ").map((x, i) => <Box key={i} className={`n${x}`} sx={{ transform: "scale(0.7)", m: -0.5 }}></Box>)
                                                                        )}
                                                                        {(item?.sanh.indexOf("Xổ số") !== -1 || item?.sanh === "XSMB" || item?.sanh === "XSMT" || item?.sanh === "XSMN") && (
                                                                            item?.id_bet?.dacbiet && <Button size="small" variant="outlined" sx={{ py: 0, fontSize: "0.75rem", textTransform: 'none', fontWeight: '700' }} onClick={() => openPopup(item?.id_bet)}>{t("view")}</Button>
                                                                        )}
                                                                        {item?.sanh.indexOf("Xóc đĩa") !== -1 && (
                                                                            item?.id_bet?.result?.split(" ").map((x, i) => <Box key={i} className={`a${x}`} sx={{ transform: "scale(0.5)", m: -1 }}></Box>)
                                                                        )}
                                                                    </Box>
                                                                )}
                                                            </TableCell>

                                                            <TableCell>
                                                                <Chip 
                                                                    label={item?.status_payment || item?.status_bet || item?.status || ""} 
                                                                    size="small"
                                                                    sx={{ 
                                                                        fontWeight: 700, fontSize: "0.7rem", borderRadius: "4px",
                                                                        backgroundColor: ((item?.status_payment || item?.status_bet || item?.status) === "Win" || (item?.status_payment || item?.status_bet || item?.status) === "Success") ? "#DCFCE7" : ((item?.status_payment || item?.status_bet || item?.status) === "Lose" ? "#FEE2E2" : "#FEF3C7"),
                                                                        color: ((item?.status_payment || item?.status_bet || item?.status) === "Win" || (item?.status_payment || item?.status_bet || item?.status) === "Success") ? "#16A34A" : ((item?.status_payment || item?.status_bet || item?.status) === "Lose" ? "#EF4444" : "#F59E0B")
                                                                    }}
                                                                />
                                                            </TableCell>

                                                            <TableCell align="right" sx={{ fontWeight: 700 }}>{item?.money?.toLocaleString("vi-VN")}</TableCell>
                                                            <TableCell align="right" sx={{ fontWeight: 800, color: '#16A34A' }}>{item?.moneythang ? "+" + item?.moneythang?.toLocaleString("vi-VN") : ""}</TableCell>
                                                            <TableCell align="right" sx={{ fontWeight: 700 }}>{item?.after?.toLocaleString("vi-VN")}</TableCell>
                                                            <TableCell align="right" sx={{ color: '#7E8299', fontSize: '0.8rem', fontWeight: 600 }}>{formatDate(new Date(item?.createdAt))}</TableCell>
                                                        </TableRow>
                                                    ))
                                                ) : (
                                                    <TableRow><TableCell colSpan={10} align="center" sx={{ py: 6, color: '#A1A5B7', fontWeight: '600' }}>Không có dữ liệu giao dịch</TableCell></TableRow>
                                                )}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                    
                                    {displayHistoryPages > 1 && (
                                        <Box sx={{ p: 2, display: "flex", justifyContent: "flex-end", borderTop: '1px solid #EFF2F5' }}>
                                            <Pagination color="primary" shape="rounded" size="small" count={displayHistoryPages} page={historyPage} onChange={handleHistoryPageChange} sx={{ '& .MuiPaginationItem-root': { fontWeight: 700 } }} />
                                        </Box>
                                    )}
                                </CardContent>
                            </Card>

                        </Container>

                        {/* --- MODAL CHỈNH SỬA BANK --- */}
                        {isShow === true ? (
                            <Box sx={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                <Card sx={{ width: '400px', p: 3 }}>
                                    <Typography variant="h6" fontWeight="800" mb={3}>{t("edit")} Ngân Hàng</Typography>
                                    <form onSubmit={handleSubmitBank}>
                                        <Stack spacing={2}>
                                            <input className="custom-input-metronic" name="name_bank" defaultValue={bank?.name_bank || ""} style={inputStyle} placeholder={t("bank_name")} />
                                            <input className="custom-input-metronic" name="stk" defaultValue={bank?.stk || ""} style={inputStyle} type="number" placeholder={t("bank_number")} />
                                            <input className="custom-input-metronic" name="fullname" defaultValue={bank?.fullname || ""} style={inputStyle} placeholder={t("bank_account")} />
                                            <Stack direction="row" spacing={2} justifyContent="flex-end" mt={2}>
                                                <Button variant="outlined" onClick={() => setShow(false)} color="inherit" sx={{ height: '46px', px: 3, borderRadius: '8px', fontWeight: '700' }}>{t("close")}</Button>
                                                <Button variant="contained" type="submit" sx={{ height: '46px', px: 4, borderRadius: '8px', boxShadow: 'none', fontWeight: '800' }}>{t("submit")}</Button>
                                            </Stack>
                                        </Stack>
                                    </form>
                                </Card>
                            </Box>
                        ) : null}

                        {/* --- MODAL QUẢN LÝ FORM SỰ KIỆN (DÙNG CHUNG CHO CẢ TẠO VÀ SỬA) --- */}
                        {showEventModal && (
                            <Box sx={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.6)', zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center', backdropFilter: 'blur(3px)' }}>
                                <Card sx={{ width: '500px', p: 4 }}>
                                    <Typography variant="h6" fontWeight="800" mb={1} color="#7239EA">
                                        {editingEvent ? "Chỉnh sửa sự kiện nạp tiền" : "Tạo sự kiện nạp tiền mới"}
                                    </Typography>
                                    <Typography variant="body2" color="text.secondary" mb={3} fontWeight="600">
                                        Sự kiện áp dụng riêng cho tài khoản <strong style={{color:"#181C32"}}>{profile?.username}</strong>.
                                    </Typography>
                                    
                                    <form key={editingEvent ? editingEvent._id : 'new'} onSubmit={handleSaveEvent}>
                                        <Stack spacing={2}>
                                            <Box>
                                                <Typography variant="caption" fontWeight="700" color="text.secondary" mb={0.5} display="block">Tiêu đề sự kiện</Typography>
                                                <input required className="custom-input-metronic" name="title" defaultValue={editingEvent ? editingEvent.title : ""} placeholder="VD: THƯỞNG NẠP LẠI VIP" style={inputStyle} />
                                            </Box>
                                            <Box>
                                                <Typography variant="caption" fontWeight="700" color="text.secondary" mb={0.5} display="block">Nội dung hiển thị</Typography>
                                                <input required className="custom-input-metronic" name="content" defaultValue={editingEvent ? editingEvent.content : ""} placeholder="VD: Tặng ngay 500K khi nạp lại..." style={inputStyle} />
                                            </Box>
                                            
                                            <Grid container spacing={2}>
                                                <Grid item xs={6}>
                                                    <Typography variant="caption" fontWeight="700" color="text.secondary" mb={0.5} display="block">Loại phần thưởng</Typography>
                                                    <select required className="custom-input-metronic" name="bonus_type" defaultValue={editingEvent ? editingEvent.bonus_type : "FIXED"} style={{...inputStyle, cursor: 'pointer'}}>
                                                        <option value="FIXED">Tiền mặt cố định</option>
                                                        <option value="PERCENT">Theo % Đơn nạp</option>
                                                    </select>
                                                </Grid>
                                                <Grid item xs={6}>
                                                    <Typography variant="caption" fontWeight="700" color="text.secondary" mb={0.5} display="block">Giá trị (VNĐ / %)</Typography>
                                                    <input required type="number" className="custom-input-metronic" name="bonus_value" defaultValue={editingEvent ? editingEvent.bonus_value : ""} placeholder="VD: 500000 hoặc 10" style={inputStyle} />
                                                </Grid>
                                            </Grid>

                                            <Grid container spacing={2}>
                                                <Grid item xs={6}>
                                                    <Typography variant="caption" fontWeight="700" color="text.secondary" mb={0.5} display="block">Số tiền nạp tối thiểu (VNĐ)</Typography>
                                                    <input required type="number" className="custom-input-metronic" name="min_deposit" defaultValue={editingEvent ? editingEvent.min_deposit : 100000} style={inputStyle} />
                                                </Grid>
                                                <Grid item xs={6}>
                                                    <Typography variant="caption" fontWeight="700" color="text.secondary" mb={0.5} display="block">Số lượt sử dụng</Typography>
                                                    <input required type="number" className="custom-input-metronic" name="turns" defaultValue={editingEvent ? (editingEvent.turns !== undefined ? editingEvent.turns : 1) : 1} placeholder="Mặc định: 1" style={inputStyle} />
                                                </Grid>
                                            </Grid>

                                            <Stack direction="row" spacing={2} justifyContent="flex-end" mt={3}>
                                                <Button variant="outlined" onClick={() => {
                                                    setShowEventModal(false);
                                                    setEditingEvent(null);
                                                }} color="inherit" sx={{ height: '46px', px: 3, borderRadius: '8px', fontWeight: '700' }}>Hủy</Button>
                                                <Button variant="contained" type="submit" sx={{ height: '46px', px: 4, borderRadius: '8px', boxShadow: 'none', fontWeight: '800', backgroundColor: '#7239EA', '&:hover': { backgroundColor: '#5014d0' } }}>
                                                    {editingEvent ? "Cập Nhật Sự Kiện" : "Lưu Sự Kiện"}
                                                </Button>
                                            </Stack>
                                        </Stack>
                                    </form>
                                </Card>
                            </Box>
                        )}
                        {/* ------------------------------------------- */}

                        {/* Các Modal khác */}
                        {isOpen === true && popup && (
                            <Box sx={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                <Card sx={{ width: '600px', maxHeight: '80vh', display: 'flex', flexDirection: 'column' }}>
                                    <Box sx={{ p: 2.5, borderBottom: '1px solid #EFF2F5' }}>
                                        <Typography variant="h6" fontWeight="800">{t("history")} <Typography component="span" color="primary" fontWeight="800">{popup[0]?.username}</Typography></Typography>
                                    </Box>
                                    <Box sx={{ p: 2.5, overflowY: 'auto', flex: 1 }}>
                                        {popup.map((item, idx) => (
                                            <Box key={idx} sx={{ p: 2, mb: 2, backgroundColor: '#F9F9F9', borderRadius: '8px', border: '1px solid #EFF2F5', display: 'flex', justifyContent: 'space-between' }}>
                                                <Box>
                                                    <Typography variant="subtitle2" fontWeight="800" color="primary" mb={0.5}>{item?.game}</Typography>
                                                    <Typography variant="caption" display="block" color="text.secondary" fontWeight="600">{t("session")}: {item?.id_bet?.id_bet || item?.id_bet}</Typography>
                                                    <Typography variant="caption" display="block" color="text.secondary" fontWeight="600">{t("commission")}: <span style={{color: '#16A34A', fontWeight: '800'}}>{Number(item?.hoahong)?.toLocaleString("vi-VN")}</span></Typography>
                                                </Box>
                                                <Box textAlign="right">
                                                    <Typography variant="body2" fontWeight="800" color="#181C32" mb={0.5}>{Number(item?.money)?.toLocaleString("vi-VN")} đ</Typography>
                                                    <Typography variant="caption" color="text.secondary" fontWeight="600">{formatDate(new Date(item?.createdAt))}</Typography>
                                                </Box>
                                            </Box>
                                        ))}
                                    </Box>
                                    <Box sx={{ p: 2, borderTop: '1px solid #EFF2F5', textAlign: 'right' }}>
                                        <Button variant="outlined" color="error" onClick={() => setOpen(false)} sx={{fontWeight: '700'}}>{t("close")}</Button>
                                    </Box>
                                </Card>
                            </Box>
                        )}

                        {isOpen2 && total ? (
                             <div className="popup-backdrop" style={{ maxWidth: "100%", zIndex: 9999 }}>
                                <div className="popup-main" style={{ maxWidth: "1460px", margin: "0 auto", backgroundColor: "#fff", borderRadius: "12px", padding: "20px" }}>
                                    <div className="popup-header" style={{ fontSize: "18px", fontWeight: "bold", marginBottom: "15px" }}>{t("session")} <span style={{color: "#2563EB"}}>{total?.id_bet}</span></div>
                                    <div className="popup-content" style={{ padding: "0" }}>
                                        <table id="table-xsmb" className="table-result table table-bordered table-striped table-xsmb" style={{ width: "100%", textAlign: "center", borderCollapse: "collapse" }}>
                                            <tbody>
                                                <tr><th style={{ width: "15%", padding: "8px", border: "1px solid #eee" }}>ĐB</th><td style={{ border: "1px solid #eee" }}><span className="special-prize div-horizontal" style={{color: "red", fontWeight: "bold", fontSize: "18px"}}>{total?.dacbiet}</span></td></tr>
                                                <tr><th style={{ padding: "8px", border: "1px solid #eee" }}>1</th><td style={{ border: "1px solid #eee", fontWeight: "bold" }}><span className="prize1 div-horizontal">{total?.nhat}</span></td></tr>
                                                <tr><th style={{ padding: "8px", border: "1px solid #eee" }}>2</th><td style={{ border: "1px solid #eee" }}><span style={{marginRight: "15px", fontWeight: "600"}}>{total?.hai?.split(" ")[0]}</span><span style={{fontWeight: "600"}}>{total?.hai?.split(" ")[1]}</span></td></tr>
                                                <tr><th style={{ padding: "8px", border: "1px solid #eee" }}>3</th><td style={{ border: "1px solid #eee" }}>{total?.ba?.split(" ").map((val, i) => (<span key={i} style={{marginRight: "10px", fontWeight: "600"}}>{val}</span>))}</td></tr>
                                                <tr><th style={{ padding: "8px", border: "1px solid #eee" }}>4</th><td style={{ border: "1px solid #eee" }}>{total?.tu?.split(" ").map((val, i) => (<span key={i} style={{marginRight: "10px", fontWeight: "600"}}>{val}</span>))}</td></tr>
                                                <tr><th style={{ padding: "8px", border: "1px solid #eee" }}>5</th><td style={{ border: "1px solid #eee" }}>{total?.nam?.split(" ").map((val, i) => (<span key={i} style={{marginRight: "10px", fontWeight: "600"}}>{val}</span>))}</td></tr>
                                                <tr><th style={{ padding: "8px", border: "1px solid #eee" }}>6</th><td style={{ border: "1px solid #eee" }}>{total?.sau?.split(" ").map((val, i) => (<span key={i} style={{marginRight: "10px", fontWeight: "600"}}>{val}</span>))}</td></tr>
                                                <tr><th style={{ padding: "8px", border: "1px solid #eee" }}>7</th><td style={{ border: "1px solid #eee" }}>{total?.bay?.split(" ").map((val, i) => (<span key={i} style={{marginRight: "10px", fontWeight: "600"}}>{val}</span>))}</td></tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div style={{ textAlign: "right", marginTop: "15px" }}>
                                        <Button variant="outlined" color="error" onClick={closePopup} sx={{fontWeight: '700'}}>{t("close")}</Button>
                                    </div>
                                </div>
                            </div>
                        ) : null}
                    </Box>
                </ThemeProvider>
            </DashboardLayout>
        </ThemeProvider>
    );
}

export default UserProfile;